import React, {useCallback, useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {getProfit, setProfitDone, setProfitTimeFrom, setProfitTimeTo} from '../../store/actions/profitActions';
import ProfitGraphHeader from './_profit-graph-header.jsx';
import ProfitGraphChart from './_profit-graph-chart.jsx';
import ProfitGraphDataTable from './_profit-graph-data-table.jsx';
import ProfitGraphInvestmentTable from './_profit-graph-investment-table.jsx';
import {formatDate, toFixedValue, formatDateText} from "../../config";
import moment from "moment/moment";

function ProfitGraph() {
    const dispatch = useDispatch();

    // Подписка на изменение стейта графика
    const timeFrom = useSelector(state => state.profit.profitTimeFrom);
    const timeTo = useSelector(state => state.profit.profitTimeTo);
    const timeFromMax = useSelector(state => state.profit.profitTimeFromMax);
    const timeToMax = useSelector(state => state.profit.profitTimeToMax);
    const getProfitDone = useSelector(state => state.profit.getProfitDone);

    const items = useSelector(state => state.profit.items);

    const translate = {
        profitUSDT: window.jsTranslations.profitChartUSDTName,
        profitPercent: window.jsTranslations.profitChartPercentName,
        countCycles: window.jsTranslations.profitChartcountCyclesName,
        amountDaily: window.jsTranslations.profitChartAmountName,
        total: window.jsTranslations.profitChartTotalName,
        profitChartDynamicProfitName: window.jsTranslations.profitChartDynamicProfitName,
        profitChartProfitPerDay: window.jsTranslations.profitChartProfitPerDay,
        profitChartProfitPerMonth: window.jsTranslations.profitChartProfitPerMonth,
        profitChartInvestment: window.jsTranslations.profitChartInvestment,
        profitChartWaitProfit: window.jsTranslations.profitChartWaitProfit,
        profitChartOpenOrders: window.jsTranslations.profitChartOpenOrders,
        profitChartInOrders: window.jsTranslations.profitChartInOrders,
        profitChartInCycles: window.jsTranslations.profitChartInCycles,
        profitChartNewCycles: window.jsTranslations.profitChartNewCycles,
        profitChartTotalInvestment: window.jsTranslations.profitChartTotalInvestment,

        profitPerDay: window.jsTranslations.profitPerDay,
        profitPerMonth: window.jsTranslations.profitPerMonth,
        profitDay: window.jsTranslations.profitDay,
        profitMonth: window.jsTranslations.profitMonth,
    }

    const classPrefix = 'profit-graph';

    // Получение данных графика
    useEffect(() => {
        console.log(timeFrom);
        console.log(timeTo);

        dispatch(getProfit());
    }, []);


    const updateTimeFrom = (newTimeFrom) => {
        dispatch(setProfitDone(false))
        dispatch(getProfit([newTimeFrom, timeTo]));
    }
    const updateTimeTo = (newTimeTo) => {
        dispatch(setProfitDone(false))
        dispatch(getProfit([timeFrom, newTimeTo]));
    }

    return <div className={`${classPrefix}`}>

        <div className={`${classPrefix}__wrapper`}>

            <ProfitGraphHeader
                classPrefix={classPrefix}
                timeFrom={timeFrom}
                timeTo={timeTo}
                timeFromMax={timeFromMax}
                timeToMax={timeToMax}
                profit={items.total.length > 0 ? toFixedValue(items.total[0].CycleProfitDONE, 2) : ''}
                profitCurr={items.total.length > 0 ? items.total[0].CycleProfitDONECurr : ''}
                profitPercent={items.total.length > 0 ? toFixedValue(items.total[0].CycleProfitDONEPrc, 2) : ''}
                updateTimeFrom={updateTimeFrom}
                updateTimeTo={updateTimeTo}
                translate={translate}
            />

            <ProfitGraphChart
                classPrefix={classPrefix}
                items={items}
                translate={translate}
                getProfitDone={getProfitDone}
            />


            <div className={`${classPrefix}__tables`}>
                <div className={`${classPrefix}__table-item`}>
                    <div className={`${classPrefix}__table-title`}>{translate.profitChartProfitPerDay}</div>
                    <ProfitGraphDataTable
                        classPrefix={classPrefix}
                        dateName={translate.profitDay}
                        dateNameFunction={(date) => moment(date * 1000).locale(window.locale).format('D MMMM YY')}
                        items={items.daily}
                        translate={translate}
                        tableName={'day'}
                        summury={false}
                        total={items.total}
                    />
                </div>
                <div className={`${classPrefix}__table-item`}>
                    <div className={`${classPrefix}__table-title`}>{translate.profitChartProfitPerMonth}</div>
                    <ProfitGraphDataTable
                        classPrefix={classPrefix}
                        dateName={translate.profitMonth}
                        dateNameFunction={(date) => moment(date * 1000).locale(window.locale).format('MMMM YY')}
                        items={items.monthly}
                        translate={translate}
                        tableName={'month'}
                        summary={true}
                        total={items.total}
                    />


                    <div className={`${classPrefix}__table-item-second`}>
                        <div
                            className={`${classPrefix}__table-title`}>{translate.profitChartInvestment} {items.investment.length > 0 ? formatDate(items.investment[0].ordTotals_to * 1000) : ''}</div>
                        <ProfitGraphInvestmentTable
                            classPrefix={classPrefix}
                            items={items.investment}
                            translate={translate}
                        />
                    </div>
                </div>

            </div>

        </div>
    </div>;
}

export default ProfitGraph;
